<template>
  <div class="queryPay page-container">
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item" :class="{'border-red':isShowBorderRed}">
              <div class="filter-item-label">
                {{ $t('components.create_time') }}
              </div>
              <el-date-picker
                v-model="search.create_time"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :picker-options="$commonFn.dateLimit(this, 15)"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item" :class="{'border-red':isShowBorderRed}">
              <div class="filter-item-label">
                {{ $t('merchantAccount.complete_time') }}
              </div>
              <el-date-picker
                v-model="search.complete_time"
                class="filter-item-value"
                :picker-options="$commonFn.dateLimit(this, 15)"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('components.status') }}</div>
              <el-select v-model="search.status_str" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in paymentStatusMap"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="filter-item" />
          </div>
          <div class="filter-operate">
            <div class="filter-operate-left">
              <el-button class="mb-10 download-btn" type="info" size="small" icon="el-icon-plus" @click="onClickCreatePaymentBtn">{{ $t('components.create') }}</el-button>
            </div>
            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn" type="primary" size="small" icon="el-icon-search" @click="onClickSearchBtn">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>

      </el-collapse-transition>
    </div>

    <div class="total-container">
      <div class="total-item">
        {{ $t('data.total_count') }}: <span style="color:#3855F1;">{{ total_count }}</span>
      </div>
      <div class="total-item">
        {{ $t('data.total_amount') }}: <span style="color:#3855F1;">{{ $store.getters.currency }} {{ total_amount || 0 }}</span>
      </div>
    </div>
    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column :label="$t('merchantAccount.transaction_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="$store.getters.isPii" :label="$t('components.transaction_country')" align="center">
          <template slot-scope="scope">
            <span>{{ $store.getters.findOnlineCountryObj(scope.row.country_code).label }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.beneficiary_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.account_name | cryptoJSAesDecrypt }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="['TH', 'AE'].includes($store.getters.curCountry.country_code)" min-width="100" :label="$t('merchantAccount.beneficiary_account_type')" align="center">
          <template slot-scope="scope">
            <span>{{ beneficiaryAccountTypeFormat(scope.row.beneficiary_account_type) }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="['TH', 'AE'].includes($store.getters.curCountry.country_code)" :label="$t('merchantAccount.beneficiary_type')" align="center">
          <template slot-scope="scope">
            <span>{{ beneficiaryTypeFormat(scope.row.beneficiary_type) }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchantAccount.receiving_channel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.code }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="110" :label="$t('merchantAccount.beneficiary_account_no')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.account_no | cryptoJSAesDecrypt }}</span>
          </template>
        </el-table-column>
        <!--受益人地址-->
        <el-table-column v-if="$store.getters.curCountry.country_code === 'AE'" min-width="140" :label="$t('map.benefit_address')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.beneficiary_address }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="110" :label="$t('components.amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.amount }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.status')" align="center">
          <template slot-scope="scope">
            <el-tag class="tag-custom" :type="getPayTransactionStatusStyle(scope.row.transaction_status)">{{ getPayTransactionStatusLabel(scope.row.transaction_status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.create_time')" align="center" width="105">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_create_time }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.complete_time')" align="center" width="105">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>

        <!--操作-->
        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.transaction_id" placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailBtn(scope.row)" />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-container">
      <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="confirm" />
    </div>
    <ChooseCreateDisbursementWayModal ref="chooseCreateDisbursementWayModal" @updateList="getList" />
    <StandardValuePaymentStepDetailsModal ref="standardValuePaymentStepDetailsModal" />

  </div>
</template>

<script>

import { queryStandardList, querySummaryStandardList } from '@/api/online-transaction/online-transaction'
import {
  poTransStatusWithRefundMap
} from '@/utils/maps'
import { appointDate } from '@/utils'
export default {
  name: 'Customer_Service_Query_Pay',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    StandardValuePaymentStepDetailsModal: () => import('./Modal/LargeValuePaymentStepDetailsModal.vue'),
    ChooseCreateDisbursementWayModal: () => import('./Modal/ChooseCreateDisbursementWayModal.vue')
  },
  data() {
    this.timer = null
    return {
      isShowBorderRed: false,
      isShowBorderInvoiceRed: false,
      showFilterContent: true,
      search: {
        create_time: [appointDate(-3), appointDate()],
        complete_time: []
      },
      tableData: [],
      payTypeArr: [], // 支付类型数组
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: 0,
      total_count: null,
      total_amount: null
    }
  },
  computed: {
    beneficiaryAccountTypeFormat() {
      const obj = {
        'BANK': this.$t('map.beneficiary_account_type_0'),
        'PROMPTPAY': this.$t('map.beneficiary_account_type_1'),
        'EWALLET': this.$t('map.beneficiary_account_type_2')
      }
      return function(value) {
        if (value) {
          return obj[value]
        }
        return value
      }
    },
    beneficiaryTypeFormat() {
      const obj = {
        'NATIONAL_ID': this.$t('map.beneficiary_type_0'),
        'MOBILE_NUMBER': this.$t('map.beneficiary_type_1'),
        'EWALLET_ID': this.$t('merchantAccount.account_type_ewallet_id')
      }
      return function(value) {
        if (value) {
          return obj[value]
        }
        return value
      }
    },
    getPayTransactionStatusLabel() {
      return function(value) {
        return poTransStatusWithRefundMap(value).label
      }
    },
    getPayTransactionStatusStyle() {
      return function(value) {
        return poTransStatusWithRefundMap(value).type
      }
    },
    paymentStatusMap() {
      let list = poTransStatusWithRefundMap()
      list = list.map(lm => {
        if (lm.value === 2) {
          lm.value = 125
        }
        return lm
      }).filter(item => ![1, 5, 99].includes(item.value))
      return list
    }
  },
  created() {
    this.onClickSearchBtn()
  },
  methods: {
    onClickCreatePaymentBtn(row) {
      this.$refs.chooseCreateDisbursementWayModal.showModal()
    },

    onClickDetailBtn(row) {
      if (!row.transaction_id) {
        this.$message.warning('Please wait for creation')
      }
      this.$refs.standardValuePaymentStepDetailsModal.showModal({ disbursement_transaction_id: row.transaction_id, remark: row.remark })
    },
    getParams(otherParams = {}) {
      const { create_time, complete_time = [], ...otherSearch } = this.search
      let params = { ...otherSearch, ...otherParams }
      if (Array.isArray(create_time) && create_time.length > 0) {
        params.transaction_create_time_start = create_time[0] + ' 00:00:00'
        params.transaction_create_time_end = create_time[1] + ' 23:59:59'
      }
      if (Array.isArray(complete_time) && complete_time.length > 0) {
        params.transaction_return_time_start = complete_time[0] + ' 00:00:00'
        params.transaction_return_time_end = complete_time[1] + ' 23:59:59'
      }
      if (!params.transaction_return_time_start && !params.transaction_create_time_start) {
        this.$message.warning('Please select the Create Time or Complete Time')
        this.doShowRedBorder()
        return
      }

      params = this.$commonFn.filterEmptyAttr(params)
      return params
    },

    confirm() {
      const { limit } = this.listQuery
      const params = {
        page: this.listQuery.page,
        limit
      }
      this.getList(params)
    },

    onClickSearchBtn() {
      if (!this.$commonFn.checkSubmitDateLimit(this.search.create_time, 15)) {
        this.$message.warning('The maximum date range  is limited to 15 days, please select again')
        return
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.complete_time, 15)) {
        this.$message.warning('The maximum date range  is limited to 15 days, please select again')
        return
      }
      this.getList()
    },
    doShowRedBorder() {
      this.isShowBorderRed = true
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.isShowBorderRed = false
      }, 5000)
    },
    // 获取请求列表
    getList(otherParams = {}) {
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.listLoading = true
      const reqEvent = [queryStandardList(params), querySummaryStandardList(params)]

      Promise.all(reqEvent).then(allRes => {
        const [res, sumRes] = allRes
        const { list, total } = res.data || {}
        this.tableData = list || []
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.total_count = sumRes.data.count
        this.total_amount = sumRes.data.amount
      }).finally(() => {
        this.listLoading = false
        this.isShowBorderRed = false
      })
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    }
  }
}
</script>maps.js

<style lang="scss" scoped>
.icon-warning-outline{
  position: relative;
  top: 2px;
  color:  #4B5567;
  font-size: 16px;
}
.queryPay_popover_title{
  text-align: center;
  color: #606266;
}
.queryPay_textarea{
  margin-bottom: 20px;
}
.queryPay_btn-container{
  margin: 0 50px;
  display: flex;
  justify-content: space-between;
}
.queryPay_size-btn{
  width: 80px;
  height: 28px;
  line-height: 6px;
}
.queryPay{
  margin: 20px;
  background: #fff;
  border-radius: 4px;
  .pagination-container{
    padding: 20px;
    margin-top: 0;
  }
  .filter-container{
    padding: 40px 0 24px 24px;
  }

  .search-frame {
    width: 256px;
    margin-bottom: 10px;
    margin-right: 5px;
  }
  // .search-btn {
  //   margin-left: 10px;
  // }
  // .tag-status{
    // text-decoration: underline;
    // cursor: pointer;
  // }
}

.total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
</style>
